/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Link, useNavigate, useParams } from "react-router-dom";
import Select, { components } from "react-select";
import { Arr, Language, Notification } from "../svg/AllSvg";
import Logo from "../../../assets/images/logo.svg"
import Logo1 from "../../../assets/images/logo1.svg"
import Logo2 from "../../../assets/images/logo2.svg"
import DarkLogo from "../../../assets/images/dark-logo.svg"
import DarkLogo1 from "../../../assets/images/dark-logo1.svg"
import DarkLogo2 from "../../../assets/images/dark-logo2.svg"
import { useEffect, useRef, useState } from "react";
import { dataActions } from "../../../shared/store/data-Slice";
import { useDispatch, useSelector } from "react-redux";
import { languages } from "../../../shared/utils/languages";
import { uiActions } from "../../../shared/store/ui-Slice";
import { useTranslation } from "react-i18next";
import useSelectPrimary from "../../../shared/hooks/use-selectPrimary";
import ProfilePopup from "./ProfilePopup";

const DropdownIndicator = (props: any) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <Arr className="min-w-[9px] fill-[#a5a5a5] dark:fill-white" />
            </components.DropdownIndicator>
        )
    );
};

const HiringHeader = () => {
    const theme: any = useSelector((state: any) => state.ui.theme);
    const lang: string = useSelector((state: any) => state.ui.lang);
    const adminUser: any = useSelector((state: any) => state.auth.adminUser);
    const profile: boolean = useSelector((state: any) => state.data.profile);
    const [langFocus, setLangFocus] = useState<boolean>(false);
    const [langValue, setLangValue] = useState<any>(null);
    const { i18n, t } = useTranslation('common');
    const params = useParams();
    const ref1: any = useRef();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let styles = useSelectPrimary(theme, false);

    useEffect(() => {
        function handleClickOutside(event: any) {
            if (ref1.current && !ref1.current.contains(event.target)) {
                dispatch(dataActions.setProfile(false));
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref1]);

    useEffect(() => {
        if (!!params?.lang) {
            if (params?.lang === "hi" || params?.lang === "en" || params?.lang === "mr") {
                let obj: any = languages?.find((item: any) => item?.value === params?.lang);

                if (!!obj && Object?.keys(obj)?.length > 0) {
                    setLangValue(obj)
                    i18n.changeLanguage(obj?.value);
                    dispatch(uiActions.changeLang(obj?.value));
                } else {
                    setLangValue({ label: "English", value: "en", text: "English" })
                    i18n.changeLanguage("en");
                    dispatch(uiActions.changeLang("en"));
                }
            } else {
                navigate("/en")
            }
        } else {
            setLangValue({ label: "English", value: "en", text: "English" })
            i18n.changeLanguage("en");
            dispatch(uiActions.changeLang("en"));
        }
    }, [params?.lang])

    const handleChange = (e: any) => {
        if (lang !== e?.value) {
            dispatch(dataActions.setSelectLang(e));
            dispatch(dataActions.setLangOpen(true));
        }
    }

    return (
        <div className="xlsm:h-[65px] mms:h-[75px] xlx:h-[100px] border-b border-[rgba(76,143,186,0.20)] flex items-center justify-center w-full bg-white dark:bg-bgDarkDull">
            <div className="h-full xlsm:!px-[15px] !px-0 container flex items-center justify-between xlsm:flex-row flex-col">
                <Link aria-label={t("aria_label.home")} title={t("aria_label.home")} to={`${!!params?.lang ? `/${params?.lang}/admin` : "/admin"}`} className="xlsm:order-1 order-2 flex items-center justify-start xlsm:w-auto w-full py-[4px] px-[10px] xlsm:p-0 hover:bg-[#f4f4f4] hover:rounded-[10px] focus:bg-[#f4f4f4] focus:rounded-[10px] dark:hover:bg-[#4c4e5e5e] dark:focus:bg-[#4c4e5e5e]">
                    <img src={lang === "en" ? `${theme === "dark" ? DarkLogo : Logo}` : lang === "hi" ? `${theme === "dark" ? DarkLogo1 : Logo1}` : `${theme === "dark" ? DarkLogo2 : Logo2}`} alt={`${lang === "en" ? "Mumbai Metro Rail Corporation Limited" : lang === "hi" ? "मुंबई मेट्रो रेल कॉर्पोरेशन लिमिटेड" : "मुंबई मेट्रो रेल कॉर्पोरेशन मर्यादित"}`} className='w-[280px] md:w-[300px] mms:w-[338px] lgl:w-[360px] xlx:w-auto' />
                </Link>

                <div className="flex items-center xlsm:order-2 order-1 xlsm:w-auto w-full justify-end py-[2px] border-b xlsm:border-0 border-[#D8D8D8] dark:border-[#454545] px-[15px] xlsm:p-0">
                    {/* language change */}
                    <div aria-label={t("aria_label.lang")} title={t("aria_label.lang")} className={`flex items-center h-full px-[10px] lg:px-[15px] ${langFocus && "shadow-[0_0_0_1px_#5b44955e] rounded-[4px]"} hover:shadow-[0_0_0_1px_#5b44955e] hover:rounded-[4px]`}>
                        <div className="mm:w-auto mm:h-auto xlsm:w-[16px] xlsm:h-[16px] w-[14px] h-[14px]">
                            <Language />
                        </div>

                        <Select options={languages} styles={styles} className="!w-full language-select" classNamePrefix="language-select" onChange={(e: any) => handleChange(e)} value={langValue} isSearchable={false} onFocus={() => setLangFocus(true)} onBlur={() => setLangFocus(false)} aria-label={t("aria_label.lang")} components={{ DropdownIndicator }} />
                    </div>

                    <div className="h-[13px] xlx:h-[15px] border-r border-[#D8D8D8] dark:border-[#454545]"></div>

                    <div className="flex items-center h-full px-[7px] lg:px-[12px]">
                        <button className="flex items-center justify-center focus:shadow-[0_0_0_1px_#5b44955e] hover:shadow-[0_0_0_1px_#5b44955e] hover:rounded-[4px] focus:rounded-[4px] p-[3px]">
                            <Notification />
                        </button>
                    </div>

                    <div className="h-[13px] xlx:h-[15px] border-r border-[#D8D8D8] dark:border-[#454545]"></div>

                    <div className="relative msm:pr-0 pr-[10px] pl-[10px] lg:pl-[15px] ml-[-6px]" ref={ref1}>
                        <button className="text-blackDark dark:text-textBlackDull font-semibold focus:shadow-[0_0_0_1px_#D8D8D8] hover:shadow-[0px_0px_0px_1px_#D8D8D8] hover:rounded-[4px] focus:rounded-[4px] px-[6px]" onClick={() => dispatch(dataActions.setProfile(true))}>
                            <h5 className="flex items-center gap-[4px] lg:gap-[8px] xlx:gap-[11px]">
                                <span className="truncate w-[80px] sm:w-auto">
                                    {adminUser?.first_name + " " + adminUser?.last_name}
                                </span>
                                <Arr className="min-w-[9px] fill-[#1C1B1F] dark:fill-white" />
                            </h5>
                        </button>
                        {profile && <ProfilePopup type="admin" />}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HiringHeader;